import axios from 'axios';
export default function initLinkOverride(element) {
	if (element.dataset.param) {
		element.addEventListener('click', async () => {
			await axios.get(element.dataset.param);
		});

	}
}
